<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>STEP 4</div>
				<h2 waHeading="l" waText>Define the Application</h2>
				<p waBody="m" waColorText="quiet" waText>&#64;NgApp names your app and sets the root component. Angular mode only.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>This step applies to Angular mode only. &#64;NgApp tells the generator the application name and root component. Hosted mode does not need an application class &mdash; the Vert.x server discovers pages and components via SPI automatically.</p>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>MyApplication.java &mdash; Angular mode only</div>
					<markdown [data]="mdContent_485" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
			</div>
		</div>
	</div>
</div>